package navigation.settings.general

import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.height
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.DpSize
import androidx.compose.ui.unit.dp
import cafe.adriel.voyager.koin.koinScreenModel
import com.essntl.core.unsplash.ui.UnsplashImage
import com.essntl.uikit.components.button.tinted.EsMediumTintedButton
import com.essntl.uikit.components.spinner.EsSpinner
import com.essntl.uikit.components.utils.spacing
import com.essntl.uikit.theme.esColorScheme
import com.essntl.uikit.theme.esTypography
import com.mohamedrejeb.calf.core.LocalPlatformContext
import com.mohamedrejeb.calf.io.getPath
import com.mohamedrejeb.calf.picker.FilePickerFileType
import com.mohamedrejeb.calf.picker.FilePickerSelectionMode
import com.mohamedrejeb.calf.picker.rememberFilePickerLauncher
import navigation.utils.NavLinkScreen

class GeneralScreenNav(
    private val onRefresh: (() -> Unit) -> Unit,
) : NavLinkScreen {

    override val defaultTitle: String get() = "General"

    @Composable
    override fun Content() {
        val generalScreenModel = koinScreenModel<GeneralScreenModel>()
        val generalState by generalScreenModel.state.collectAsState()

        val context = LocalPlatformContext.current

        val logo = generalState.getLogo.data?.url

        val pickerLauncher = rememberFilePickerLauncher(
            type = FilePickerFileType.Image,
            selectionMode = FilePickerSelectionMode.Single,
            onResult = { files ->
                try {
                    files.firstOrNull()?.let { file ->
                        generalScreenModel.onEvent(
                            GeneralEvent.UpdateLogo(
                                file = file,
                                context = context,
                            ),
                        )
                    }
                } catch (e: Exception) {
                    println("Error: $e")
                }
            },
        )

        LaunchedEffect(Unit) {
            generalScreenModel.onEvent(GeneralEvent.GetLogo)
            onRefresh {
                generalScreenModel.onEvent(GeneralEvent.GetLogo)
            }
        }

        Column {
            if (generalState.deleting)
                Row(
                    horizontalArrangement = Arrangement.spacedBy(.5.spacing),
                ) {
                    Text(
                        text = "Deleting...",
                        color = MaterialTheme.esColorScheme.textPrimary,
                        style = MaterialTheme.esTypography.h4SemiBold20,
                    )

                    EsSpinner()
                }
            else
                Text(
                    text = "Organization Logo",
                    color = MaterialTheme.esColorScheme.textPrimary,
                    style = MaterialTheme.esTypography.h4SemiBold20,
                )

            Spacer(modifier = Modifier.height(2.spacing))

            if (!logo.isNullOrEmpty()) {
                UnsplashImage(
                    url = logo,
                    selectable = false,
                    imageSize = DpSize(264.dp, 160.dp),
                    onDelete = {
                        generalScreenModel.onEvent(GeneralEvent.DeleteLogo)
                    },
                )

                Spacer(modifier = Modifier.height(2.spacing))
            } else
                EsMediumTintedButton(
                    text = "Upload Logo",
                    loading = generalState.getLogo.isLoading,
                    onClick = { pickerLauncher.launch() },
                )
        }
    }
}